import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { defaultMaterials } from "@/lib/vvMaint";

const Row = ({ i, editable, onToggle, onRemove }) => (
  <div className="flex items-center gap-2 text-sm">
    <Checkbox checked={i.checked} disabled={!editable} onCheckedChange={(v) => onToggle(!!v)} data-testid={`vv-material-${i.id}`} />
    <span className={i.checked ? "text-muted-foreground line-through" : ""}>{i.label}</span>
    {i.extra && editable && <button type="button" onClick={onRemove} className="ml-auto" aria-label="Quitar" data-testid={`vv-material-${i.id}-remove`}><Trash2 className="h-3.5 w-3.5 text-destructive" /></button>}
  </div>
);

export const MaterialsChecklist = ({ wo, setWo, editable }) => {
  const [items, setItems] = useState(wo.extensions?.vv_materials || defaultMaterials());
  const [extra, setExtra] = useState("");
  const [busy, setBusy] = useState(false);
  const [dirty, setDirty] = useState(false);
  const upd = (next) => { setItems(next); setDirty(true); };
  const add = () => { upd([...items, { id: `extra-${Date.now()}`, group: "Adicionales", label: extra.trim(), checked: false, extra: true }]); setExtra(""); };
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/work-orders/${wo.id}/materials`, { items });
      setWo((w) => ({ ...w, extensions: { ...(w.extensions || {}), vv_materials: data } }));
      setDirty(false);
      toast.success("Checklist de materiales guardado");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const groups = [...new Set(items.map((i) => i.group))];
  return (
    <div className="space-y-4" data-testid="vv-materials">
      <p className="text-xs text-muted-foreground">Lista de planeación para preparar y llevar al servicio. No consulta ni descuenta inventario · <span data-testid="vv-materials-count">{items.filter((i) => i.checked).length}/{items.length}</span> listos</p>
      {groups.map((g) => (
        <div key={g} data-testid={`vv-materials-group-${g}`}>
          <div className="mb-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">{g}</div>
          <div className="grid gap-1.5 sm:grid-cols-2">{items.filter((i) => i.group === g).map((i) => <Row key={i.id} i={i} editable={editable}
            onToggle={(v) => upd(items.map((x) => (x.id === i.id ? { ...x, checked: v } : x)))} onRemove={() => upd(items.filter((x) => x.id !== i.id))} />)}</div>
        </div>
      ))}
      {editable && <div className="flex gap-2"><Input value={extra} onChange={(e) => setExtra(e.target.value)} placeholder="Agregar material o herramienta adicional" data-testid="vv-material-extra-input" />
        <Button variant="outline" onClick={add} disabled={!extra.trim()} data-testid="vv-material-extra-add"><Plus className="mr-1 h-4 w-4" />Agregar</Button></div>}
      {editable && dirty && <Button className="w-full" onClick={save} disabled={busy} data-testid="vv-materials-save">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Guardar checklist de materiales</Button>}
    </div>
  );
};
